export const languages = {
  vi: 'vi',
  en: 'en',
}

export const DEFAULT_LANGUAGE = languages.en
